import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { MotionButton, useMotionPresets } from "@/lib/motion";
import { toast } from "sonner";
import { LockKeyhole, CheckCircle2, Loader2 } from "lucide-react";

// Recruiter view: Safe Exam Browser status for one candidate + "allow lockdown mode instead".
export function SebCandidateCard({ candId }) {
  const [s, setS] = useState(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const M = useMotionPresets();
  useEffect(() => { api.get(`/candidates/${candId}/seb`).then(({ data }) => setS(data)).catch(() => {}); }, [candId]);
  if (!s?.required) return null;
  const set = async (exempt) => {
    setBusy(true);
    try { const { data } = await api.post(`/candidates/${candId}/seb/exempt`, { exempt, note }); setS(data); setNote(""); toast.success(exempt ? "They can take the test in Chrome or Edge lockdown mode" : "Safe Exam Browser is required again"); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not save"); }
    finally { setBusy(false); }
  };
  return (
    <motion.div variants={M.fadeInUp} initial="hidden" animate="show" className="rounded-xl border border-border bg-card p-4 space-y-3 mb-4" data-testid="seb-candidate-card">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-2"><LockKeyhole className="h-4 w-4 text-primary mt-0.5" />
          <div><div className="text-sm font-medium">Safe Exam Browser required</div>
            <div className="text-xs text-muted-foreground" data-testid="seb-candidate-status">
              {s.exempt ? `Allowed lockdown mode instead${s.exempted_by ? ` by ${s.exempted_by}` : ""}${s.exempt_note ? ` — ${s.exempt_note}` : ""}` : s.verified_at ? `Verified in Safe Exam Browser · ${new Date(s.verified_at).toLocaleString()}` : s.launched_at ? "Opened the app, not verified yet" : "Hasn't opened the test yet"}
            </div></div></div>
        {s.verified_at && !s.exempt && <CheckCircle2 className="h-4 w-4 text-emerald-400 shrink-0" />}
      </div>
      {s.exempt ? (
        <MotionButton whileTap={{ scale: 0.97 }} size="sm" variant="outline" onClick={() => set(false)} disabled={busy} data-testid="seb-require-again">{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Require Safe Exam Browser again"}</MotionButton>
      ) : !s.verified_at && (
        <div className="flex flex-wrap gap-2">
          <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Reason (e.g. only has a Chromebook)" className="h-9 flex-1 min-w-[200px]" data-testid="seb-exempt-note" />
          <MotionButton whileTap={{ scale: 0.97 }} size="sm" variant="outline" onClick={() => set(true)} disabled={busy} data-testid="seb-exempt-btn">{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Allow lockdown mode instead"}</MotionButton>
        </div>
      )}
    </motion.div>
  );
}
